module.exports = __webpack_public_path__ + "static/media/logos-logoharineradeoriente.6c9682d0.png";